export default {"src":"/_next/static/media/facebook.84e0c788.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};